<template>
  <span class="tw-text-lg tw-font-medium tw-text-dorian-gray-500">
    <slot />
  </span>
</template>
